import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      addressForm: {
        title: "Verify Your Address",
        address1: "Address Line 1",
        address1Placeholder: "e.g., 123 Main St",
        city: "City",
        cityPlaceholder: "e.g., Vancouver",
        province: "Province/State (optional)",
        provincePlaceholder: "e.g., BC",
        country: "Country",
        zip: "Postal/ZIP Code (optional)",
        zipPlaceholder: "e.g., V6C 0A0",
        landmark: "Landmark (optional)",
        landmarkPlaceholder: "e.g., Near Central Park",
        pobox: "PO Box addresses are not supported for shipping.",
        freight: "Freight addresses are not supported for shipping.",
        mailbox: "Mailbox addresses are not supported for shipping.",
        rural: "Rural addresses may require additional verification.",
        mismatch: "Address mismatch detected:",
        invalid: "Invalid address provided.",
        valid: "Address is valid.",
        suggestedAddress: "Did you mean",
        useSuggested: "Use Suggested",
        keepOriginal: "Keep Original",
        verify: "Verify Address",
        verifying: "Verifying...",
        autocompleteError: "Failed to fetch autocomplete suggestions.",
        verifyError: "Failed to verify address.",
      },
      validationResult: {
        title: "Address Validation Result",
        formattedAddress: "Formatted Address",
        warning: "Warning",
        coordinates: "Coordinates",
        latitude: "Latitude",
        longitude: "Longitude",
        provider: "Provider",
        usage: "Usage",
        validationsUsed: "validations used",
        remaining: "remaining",
        limitExceeded: "Limit Exceeded",
        pobox: "PO Box addresses are not supported for shipping.",
        freight: "Freight addresses are not supported for shipping.",
        mailbox: "Mailbox addresses are not supported for shipping.",
        rural: "Rural addresses may require additional verification.",
        mismatch: "Address mismatch detected:",
        invalid: "Invalid address provided.",
        valid: "Address is valid.",
      },
      settings: {
        title: "Settings",
        validationMode: "Validation Mode",
        warnOnly: "Warn Only",
        requireCorrection: "Require Correction",
        poBoxHandling: "PO Box Handling",
        allow: "Allow",
        warn: "Warn",
        block: "Block",
        costPerFailedShipment: "Cost per Failed Shipment ($)",
        customWarning: "Custom Warning Message",
        language: "Language",
        english: "English",
        french: "French",
        spanish: "Spanish",
        save: "Save Settings",
        saving: "Saving...",
        saved: "Settings saved successfully.",
        fetchError: "Failed to fetch settings.",
        saveError: "Failed to save settings.",
      },
      addressLogs: {
        title: "Address Logs",
        address: "Address",
        city: "City",
        country: "Country",
        status: "Status",
        timestamp: "Timestamp",
        pobox: "PO Box",
        freight: "Freight",
        mailbox: "Mailbox",
        rural: "Rural",
        mismatch: "Mismatch",
        invalid: "Invalid",
        valid: "Valid",
        fetchError: "Failed to fetch address logs.",
        loading: "Loading logs...",
      },
      navbar: {
        validateAddress: "Validate Address",
        plans: "Plans",
        dashboard: "Dashboard",
        addressLogs: "Address Logs",
        settings: "Settings",
        admin: "Admin",
      },
      adminDashboard: {
        title: "Admin Dashboard",
        plan: "Plan",
        shop: "Shop",
        validationsUsed: "Validations Used",
        validationsLeft: "Validations Left",
        correctedAddresses: "Failed Deliveries Prevented",
        costSaved: "$ Saved",
        freePlan: "Free",
        fetchError: "Failed to fetch admin data.",
      },
      dashboardHome: {
        message: "Dashboard home page coming soon.",
      },
      plans: {
        message: "Plans page coming soon.",
      },
    },
  },
  fr: {
    translation: {
      addressForm: {
        title: "Vérifiez votre adresse",
        address1: "Adresse ligne 1",
        address1Placeholder: "ex., 123 Rue Principale",
        city: "Ville",
        cityPlaceholder: "ex., Vancouver",
        province: "Province/État (facultatif)",
        provincePlaceholder: "ex., QC",
        country: "Pays",
        zip: "Code postal (facultatif)",
        zipPlaceholder: "ex., H3B 0A0",
        landmark: "Point de repère (facultatif)",
        landmarkPlaceholder: "ex., Près du Parc Central",
        pobox:
          "Les adresses de boîtes postales ne sont pas prises en charge pour l'expédition.",
        freight:
          "Les adresses de fret ne sont pas prises en charge pour l'expédition.",
        mailbox:
          "Les adresses de boîtes aux lettres ne sont pas prises en charge pour l'expédition.",
        rural:
          "Les adresses rurales peuvent nécessiter une vérification supplémentaire.",
        mismatch: "Incohérence d'adresse détectée :",
        invalid: "Adresse fournie invalide.",
        valid: "L'adresse est valide.",
        suggestedAddress: "Vouliez-vous dire",
        useSuggested: "Utiliser l'adresse suggérée",
        keepOriginal: "Conserver l'original",
        verify: "Vérifier l'adresse",
        verifying: "Vérification en cours...",
        autocompleteError:
          "Échec de la récupération des suggestions d'autocomplétion.",
        verifyError: "Échec de la vérification de l'adresse.",
      },
      validationResult: {
        /* ... from previous */
      },
      settings: {
        /* ... from previous */
      },
      addressLogs: {
        /* ... from previous */
      },
      navbar: {
        validateAddress: "Vérifier l'adresse",
        plans: "Plans",
        dashboard: "Tableau de bord",
        addressLogs: "Journaux d'adresse",
        settings: "Paramètres",
        admin: "Admin",
      },
      adminDashboard: {
        title: "Tableau de bord admin",
        plan: "Plan",
        shop: "Boutique",
        validationsUsed: "Validations utilisées",
        validationsLeft: "Validations restantes",
        correctedAddresses: "Livraisons échouées évitées",
        costSaved: "$ Économisé",
        freePlan: "Gratuit",
        fetchError: "Échec de la récupération des données admin.",
      },
      dashboardHome: {
        message: "Page d'accueil du tableau de bord à venir.",
      },
      plans: {
        message: "Page des plans à venir.",
      },
    },
  },
  es: {
    translation: {
      addressForm: {
        title: "Verifique su dirección",
        address1: "Línea de dirección 1",
        address1Placeholder: "p.ej., 123 Calle Principal",
        city: "Ciudad",
        cityPlaceholder: "p.ej., Vancouver",
        province: "Provincia/Estado (opcional)",
        provincePlaceholder: "p.ej., BC",
        country: "País",
        zip: "Código postal (opcional)",
        zipPlaceholder: "p.ej., V6C 0A0",
        landmark: "Punto de referencia (opcional)",
        landmarkPlaceholder: "p.ej., Cerca del Parque Central",
        pobox: "No se admiten direcciones de apartados postales para envíos.",
        freight: "No se admiten direcciones de flete para envíos.",
        mailbox: "No se admiten direcciones de buzones para envíos.",
        rural:
          "Las direcciones rurales pueden requerir verificación adicional.",
        mismatch: "Se detectó una discrepancia en la dirección:",
        invalid: "Dirección proporcionada no válida.",
        valid: "La dirección es válida.",
        suggestedAddress: "¿Quiso decir",
        useSuggested: "Usar sugerida",
        keepOriginal: "Mantener original",
        verify: "Verificar dirección",
        verifying: "Verificando...",
        autocompleteError: "Error al obtener sugerencias de autocompletado.",
        verifyError: "Error al verificar la dirección.",
      },
      validationResult: {
        /* ... from previous */
      },
      settings: {
        /* ... from previous */
      },
      addressLogs: {
        /* ... from previous */
      },
      navbar: {
        validateAddress: "Verificar dirección",
        plans: "Planes",
        dashboard: "Tablero",
        addressLogs: "Registros de dirección",
        settings: "Configuraciones",
        admin: "Admin",
      },
      adminDashboard: {
        title: "Tablero de administración",
        plan: "Plan",
        shop: "Tienda",
        validationsUsed: "Validaciones usadas",
        validationsLeft: "Validaciones restantes",
        correctedAddresses: "Entregas fallidas evitadas",
        costSaved: "$ Ahorrado",
        freePlan: "Gratis",
        fetchError: "Error al obtener datos de administración.",
      },
      dashboardHome: {
        message: "Página de inicio del tablero pronto estará disponible.",
      },
      plans: {
        message: "Página de planes pronto estará disponible.",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      lookupQuerystring: "lng",
    },
  });

export default i18n;
